import App from 'app/app.js';

function LtOrderStatusDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      orderStatusData: '=',
      onCancellation: '&'
    },
    template:
      '<div class="order-status-drawer" ng-init="orderStatusDrawer.init()" lt-drawer="orderStatusDrawer.visible" lt-drawer-cancellation="orderStatusDrawer.cancel()">' +
      '   <div class="modal-content">' +
      '       <div class="order-status-entry col-xs-12">' +
      '           <h5 class="text-center" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_TITLE"></h5>' +
      '           <span class="order-status-text-nb" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_ORDER" lt-translate-values="{orderNumber: orderStatusData.orderId}"></span>' +
      '           <span class="order-status-text-db" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_ORDERED" lt-translate-values="{orderDate: ( orderStatusData.orderedOn  | date:\'MMMM d, y\' )}"></span>' +
      '           <span class="order-status-text-mb" ng-show="!!orderStatusData.showOnlinePaymentId" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_ONLINE_PAYMENT_ID" lt-translate-values="{onlinePaymentId: orderStatusData.onlinePaymentId}">{{orderStatusData.onlinePaymentId}}</span>' +
      '           <span class="order-status-separator"></span>' +
      '           <span class="order-status-label" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_ITEM"></span>' +
      '           <span class="order-status-text-b" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_STATUS"></span>' +
      '           <div ng-repeat="orderLine in orderStatusData.orderLines">' +
      '               <span class="order-status-label-nb"  ng-bind="orderLine.itemDescription" data-test-status-item-description></span> ' +
      '                   <span class="order-status-text" ng-show="!orderLine.shipDate" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_PROCESSING"></span>' +
      '                   <span class="order-status-text" ng-show="!!orderLine.shipDate" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_SHIPPED"></span>' +
      '           </div>' +
      '       </div>' +
      '       <div class="cancel-link-pad" align="center">' +
      '           <div class="col-xs-12">' +
      '               <a id="status-close-btn" ng-click="orderStatusDrawer.close()" class="btn blue" lt-translate="ORDER_DETAIL_ORDER_STATUS_DRAWER_CLOSE_BUTTON_TEXT" data-id="button"></a>' +
      '           </div>' +
      '        </div>' +
      '    </div>' +
      '</div>',
    controller: 'LtOrderStatusDrawerCtrl',
    controllerAs: 'orderStatusDrawer'
  };
}

App.directive('ltOrderStatusDrawer', [LtOrderStatusDrawerDirective]);
